import request from '@/utils/request'

// 根据身份证查询档案信息
export function getHealthyCard(data) {
  return request({
    url: '/api/record/get/idCard',
    method: 'get',
    params: data,
  })
}

// 淮南修改电子健康卡
export function changeHealthyCard(data) {
  return request({
    url: '/api/record/edit/hnCard',
    method: 'post',
    data,
  })
}
